function addBodyClass() {
  document.body.classList.add('drag-in-progress');
}

function removeBodyClass() {
  document.body.classList.remove('drag-in-progress');
}

export default {
  addBodyClass,
  removeBodyClass,
};
